<button mat-icon-button [matMenuTriggerFor]="flagsMenu" #flagsMenuTrigger="matMenuTrigger">
  <mat-icon>g_translate</mat-icon>
</button>
<mat-menu #flagsMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu flags">
  <button mat-menu-item (mousedown)="onMenuItemClicked($event, 'ar')">
    <img src="assets/img/flags/eg.svg" width="20" alt="عربي" />
    عربي
  </button>
  <button mat-menu-item (mousedown)="onMenuItemClicked($event, 'en')">
    <img src="assets/img/flags/gb.svg" width="20" alt="english" />
    English
  </button>
</mat-menu>
